module.exports = {
  DEBUG: process.env.NODE_ENV === 'development',

  siteName: 'CreativeStudio',
  author: 'Parminder Klair',
  description: 'A starting point using ReactJs, bundled with awesome GatsbyJs.',
  siteUrl: 'http://kickoff-gatsbyjs.netlify.com',
  logo: '/images/logo-1024.png',

  telephone: '+91-9878448082',
  email: 'preetx025@gmail.com',
  location: 'United Streets Of ATTA , (USA)',
  twitter: '@NAME-HERE',
  fbUserId: '@NAME-HERE',
  fbAppID: '@NAME-HERE',

  type: 'website',
  googleAnalytics: '',
  backgroundColor: '#e0e0e0',
  themeColor: '#c62828',
};
